import React, { ReactNode } from 'react'
import { IconButton, Panel } from 'rsuite'
import ExitIcon from '@rsuite/icons/Exit'
import HelpOutlineIcon from '@rsuite/icons/HelpOutline'
import Link from 'next/link'
import Image from 'next/image'
import { VERSION_NUMBER } from '../../config'
import CustomText from '../base/CustomText'
import { useAuthStore } from '../../dataStores/auth'
import SEO from './SEO'
import Container from './Container'
import SignOutWhisper from './SignOutWhisper'

type Props = {
  children?: ReactNode
  title?: string
  maxWidth?: number
  showLogo?: boolean
}

const CenterLayout = ({ children, title, maxWidth, showLogo }: Props): JSX.Element => {
  const user = useAuthStore((state) => state.user)

  return (
    <div>
      <SEO title={title} />
      {showLogo ? (
        <div className="w-full h-52 sm:h-72 bg-primary flex flex-col items-center justify-center gap-4">
          <Image src="/static/images/logo-light.svg" alt="Elecnor logo" width={600 * 0.3} height={310 * 0.3} />
          <CustomText size="subtitle-1" weight={400} className="uppercase text-white opacity-75">
            <span className="hidden sm:inline">Sistema integrado de mantenimiento de alumbrado público</span>
            <span className="inline sm:hidden">SIMAP Chile</span>
          </CustomText>
        </div>
      ) : (
        <div className="w-full h-12 sm:h-40 bg-primary" />
      )}
      <div className="relative">
        <div className="absolute top-0 left-0 w-full h-20 bg-primary z-10" />
        <div className="flex flex-col justify-center relative z-20">
          <Container maxWidth={maxWidth}>
            <div className="space-y-20 pb-20">
              <div>{children}</div>

              <Panel shaded className="bg-white !overflow-visible">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    {user ? (
                      <SignOutWhisper>
                        <IconButton icon={<ExitIcon />} className="!flex items-center space-x-2 !text-danger" />
                      </SignOutWhisper>
                    ) : null}

                    <IconButton
                      icon={<HelpOutlineIcon />}
                      className="!flex items-center space-x-2"
                      as="a"
                      href="/help"
                      target="_blank"
                    />
                  </div>

                  <Link href="/changelog">
                    <a target="_blank">
                      <CustomText size="tiny" weight={400} className="text-center text-gray-dark hover:underline">
                        SIMAP V{VERSION_NUMBER}
                      </CustomText>
                    </a>
                  </Link>
                </div>
              </Panel>
            </div>
          </Container>
        </div>
      </div>
    </div>
  )
}

export default CenterLayout
